import type { SystemMonospaceFile as FileType } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { createFileHooks } from '~/rstore/utils/collections/files';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const FILE_DATETIME_FIELDS = ['createdAt', 'updatedAt'] as const;

export const SystemMonospaceFile = RStoreSchema.withItemType<FileType>().defineCollection({
	name: 'SystemMonospaceFile',
	scopeId: 'monospace-default',
	fields: defineSystemDateTimeFields(FILE_DATETIME_FIELDS),
	meta: {
		defaultFields: [
			'id',
			'fileName',
			'fileSize',
			'mediaType',
			'createdAt',
			'updatedAt',
		],
		endpoint: 'system/files',
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(FILE_DATETIME_FIELDS),
	},
	hooks: createFileHooks('system'),
});
